exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popup-parent--hidden {\n  overflow: hidden !important;\n}\n.el-popup-parent--hidden .fixed-header {\n  padding-right: 0.9375rem;\n}", ""]);

// exports
